export default __webpack_public_path__ + "static/media/play-circle.8655ded1.svg";